export default __webpack_public_path__ + "static/Sentry-16a4b51c345de3bd489b545dac498e09.png";